import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing, colors }: Theme) => createStyles({
  enabled: {
    width: '100%',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    padding: spacing(2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: colors.pageElements.dropdownMenuOption.enabled.name,
    '&:hover': {
      color: colors.pageElements.dropdownMenuOption.hovered.name,
      backgroundColor: colors.pageElements.dropdownMenuOption.hovered.background,
    },
  },
  small: {
    padding: `${spacing(1) + 3}px ${spacing(2)}px ${spacing(1) + 3}px ${spacing(2)}px`,
    '& svg': {
      fontSize: spacing(3),
    },
  },
  plain: {
    pointerEvents: 'none',
    cursor: 'default',
  },
  value: {
    position: 'relative',
  },
  icon: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
});

export default styles;
